/**
 * Copyright (c) Amur 2020
 *
 * React-js-loader by Amur
 * https://github.com/AmurKhoyetsyan/react-js-loader
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Heart = _interopRequireDefault(require("./Heart"));

var _Box = _interopRequireDefault(require("./Box/Box1"));

var _Box2 = _interopRequireDefault(require("./Box/Box2"));

var _Box3 = _interopRequireDefault(require("./Box/Box3"));

var _Box4 = _interopRequireDefault(require("./Box/Box4"));

var _Box5 = _interopRequireDefault(require("./Box/Box5"));

var _Box6 = _interopRequireDefault(require("./Box/Box6"));

var _Bubble = _interopRequireDefault(require("./Bubble/Bubble1"));

var _Bubble2 = _interopRequireDefault(require("./Bubble/Bubble2"));

var _Bubble3 = _interopRequireDefault(require("./Bubble/Bubble3"));

var _Bubble4 = _interopRequireDefault(require("./Bubble/Bubble4"));

var _Spinner = _interopRequireDefault(require("./Spinner/Spinner1"));

var _Spinner2 = _interopRequireDefault(require("./Spinner/Spinner2"));

var _Spinner3 = _interopRequireDefault(require("./Spinner/Spinner3"));

var _Ekvalayzer = _interopRequireDefault(require("./Ekvalayzer"));

var _Hourglass = _interopRequireDefault(require("./Hourglass"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Loader = function Loader(props) {
  var _useState = (0, _react.useState)({
        type: "spinner-default",
        bgColor: "#FFFFFF"
      }),
      _useState2 = _slicedToArray(_useState, 2),
      defaultProps = _useState2[0],
      setProps = _useState2[1];

  (0, _react.useEffect)(function () {
    if (Object.keys(props).length === 0) {
      props = defaultProps;
    }

    var newProps = { ...props
    };

    if (!newProps.hasOwnProperty("type")) {
      newProps.type = defaultProps.type;
    }

    if (!newProps.hasOwnProperty("bgColor")) {
      newProps.bgColor = defaultProps.bgColor;
    }

    setProps(newProps);
  }, []);

  switch (defaultProps.type) {
    case "box-rotate-x":
      return _react.default.createElement(_Box.default, defaultProps);

    case "box-rotate-y":
      return _react.default.createElement(_Box2.default, defaultProps);

    case "box-rotate-z":
      return _react.default.createElement(_Box3.default, defaultProps);

    case "box-rectangular":
      return _react.default.createElement(_Box4.default, defaultProps);

    case "rectangular-ping":
      return _react.default.createElement(_Box5.default, defaultProps);

    case "box-up":
      return _react.default.createElement(_Box6.default, defaultProps);

    case "heart":
      return _react.default.createElement(_Heart.default, defaultProps);

    case "bubble-scale":
      return _react.default.createElement(_Bubble.default, defaultProps);

    case "bubble-top":
      return _react.default.createElement(_Bubble2.default, defaultProps);

    case "bubble-ping":
      return _react.default.createElement(_Bubble3.default, defaultProps);

    case "bubble-spin":
      return _react.default.createElement(_Bubble4.default, defaultProps);

    case "spinner-cub":
      return _react.default.createElement(_Spinner.default, defaultProps);

    case "spinner-circle":
      return _react.default.createElement(_Spinner2.default, defaultProps);

    case "spinner-default":
      return _react.default.createElement(_Spinner3.default, defaultProps);

    case "ekvalayzer":
      return _react.default.createElement(_Ekvalayzer.default, defaultProps);

    case "hourglass":
      return _react.default.createElement(_Hourglass.default, defaultProps);

    default:
      return _react.default.createElement(_Spinner3.default, defaultProps);
  }
};

var _default = Loader;
exports.default = _default;